import state from './smsCountState'
import getters from './smsCountGetters'
import actions from './smsCountActions'
import mutations from './smsCountMutations'

export default {
  namespaced : true,
  state : state,
  getters : getters,
  actions : actions,
  mutations : mutations
}

